import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const Security = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Whitepaper.pdf";

  return (
    <>
      <div className="security-container">
        <h1>Security, Privacy & Anti-Fraud Statement</h1>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="lock-icon"></i>
          </div>
          <h2>Limited Metadata Collection</h2>
          <p>
            Omega Void&reg; collects limited technical metadata strictly for platform security and abuse
            prevention. This includes IP address and device identifiers used to detect bot activity, prevent
            mass account creation, enforce rate limits, and protect infrastructure from automated attacks.
            This data is never used to identify users personally, is not sold or shared with third parties,
            and is not connected to names, email addresses, or real-world identity. Omega Void does
            not collect personal information.
          </p>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="key-icon"></i>
          </div>
          <h2>Secure Login System</h2>
          <p>
            Login is handled exclusively using the Login ID issued at registration. A Recovery Key/ID
            is generated at the time of registration — users must store this safely.
          </p>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="shield-icon"></i>
          </div>
          <h2>Official Communications</h2>
          <p>
            Omega Void will not request passwords, recovery credentials, access keys or
            other sensitive authentication information by email. Official Omega Void
            communications will originate only from email domains and addresses identified
            on this website.
          </p>
          <div className="alert-box">
            <p>
              If you receive suspicious communications claiming to represent Omega Void,
              contact <strong>support@omegavoid.com</strong> to verify them.
            </p>
          </div>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="bitcoin-icon"></i>
          </div>
          <h2>Identity-Minimized Architecture</h2>
          <ul style={{ textAlign: 'left', lineHeight: '1.8', listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>The platform does not rely on names, personal email addresses, or public identity profiles for user accounts.</li>
            <li>Login and access are based on platform-issued identifiers and user-controlled access credentials.</li>
            <li>Identity information is minimized and separated from message delivery.</li>
            <li>Encrypted message blobs, encrypted access-key data, and Omega Inbox synchronization are handled through centralized cloud infrastructure.</li>
            <li>Centralized infrastructure is used for delivery and synchronization without requiring users to establish a conventional real-world identity profile.</li>
          </ul>
        </div>

        <div className="home-patent-notice" style={{ marginBottom: '30px' }}>
          <p>Technical Audit Coming Q3-Q4 2028</p>
          <div className="patent-badge">
            <span className="patent-text">PATENT PENDING</span>
          </div>
          <p className="patent-subtitle">
            Certain technologies and methods associated with Omega Void are the subject of pending patent protection.
          </p>
        </div>

        <div className="hardware-promo">
          <h3>Omega Void&reg; Whitepaper</h3>
          <p>
          This is the Omega Void Security Whitepaper. This is to ensure we remain transparent in everything we do on this website,
what we collect during your interactions with the site and our encryption procedures.
          </p>

          <div className="whitepaper-pdf-section" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading whitepaper document..." />
          </div>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default Security;
